import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  ApproveOutcomingRequests,
  GetOutgoingHGOFilteredRequests,
  GetOutgoingHGORequests,
  GetOutgoingMonazamFilteredRequests,
  GetOutgoingMonazamRequests,
  RejectOutcomingRequests,
} from "../../../../../Actions/RequestActions";
import { formatAmount, SuccessToast } from "../../../../../Util";
import { Spinner } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import "./Table.css";

const Table = ({ reload, filters, setTotalPages, page, setPage }) => {
  const { userType } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleApprove = () => {
    SuccessToast("Request approved successfully.");
    fetchOutgoingRequests();
  };

  const handleReject = () => {
    SuccessToast("Request rejected successfully.");
    fetchOutgoingRequests();
  };

  const approveRequest = (request) => {
    ApproveOutcomingRequests(request.id, setError, handleApprove);
  };

  const rejectRequest = (request) => {
    RejectOutcomingRequests(request.id, setError, handleReject);
  };

  const fetchFilteredOutgoingRequests = async () => {
    if (userType === "monazam") {
      GetOutgoingMonazamFilteredRequests(
        filters,
        setData,
        1,
        setLoading,
        setError,
        setTotalPages
      );
    } else if (userType === "hgo") {
      GetOutgoingHGOFilteredRequests(
        filters,
        setData,
        1,
        setTotalPages,
        setLoading,
        setError
      );
    }
    setPage(1);
  };

  const fetchOutgoingRequests = async () => {
    setLoading(true);
    if (userType === "monazam") {
      GetOutgoingMonazamRequests(
        setData,
        setLoading,
        setError,
        page,
        setTotalPages
      );
    } else if (userType === "hgo") {
      GetOutgoingHGORequests(
        setData,
        setLoading,
        setError,
        page,
        setTotalPages
      );
    }
  };

  useEffect(() => {
    if (!filters.date && !filters.categoryType && !filters.currency) {
      fetchOutgoingRequests();
    } else {
      fetchFilteredOutgoingRequests();
    }
  }, [reload, userType, filters, page]);

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center loading-container">
        <Spinner animation="border" className="spinner-green" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  else if (!!error) return <p>{error}</p>;
  else
    return (
      <div className={`table-responsive ${userType === "monazam" ? "outgoing-table-container-monazam" : "outgoing-table-container"}`}>
        <table className={`table ${userType === "monazam" ? "outgoing-table-monazam-portal" : "outgoing-table-hgo"}`}>
          <thead>
            <tr>
              {userType === "monazam" && (
                <th className="tableheader-txt py-3">HGO Name</th>
              )}
              <th className="tableheader-txt py-3">Date / Time</th>
              <th className="tableheader-txt py-3">Narration</th>
              <th className="tableheader-txt py-3">Type</th>
              <th className="tableheader-txt py-3 col-currency">Currency</th>
              <th className="tableheader-txt py-3 col-amount">Amount</th>
              <th className="tableheader-txt py-3">Letter of Consent</th>
              <th className="tableheader-txt py-3 col-actions">
                {userType === "monazam" ? "Actions" : "Status"}
              </th>
            </tr>
          </thead>
          <tbody>
            {data
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((request, index) => (
              <tr key={index}>
                {userType === "monazam" && (
                  <td className="tabledata-txt py-3">
                    {request.hgoUser?.name}
                  </td>
                )}
                <td className="tabledata-txt py-3">
                  {(() => {
                    const isoString = request.date;
                    const [datePart, timePart] = isoString.split('T');
                    const [year, month, day] = datePart.split('-');
                    const [time, timezone] = timePart.split('.');
                    const [hours, minutes, seconds] = time.split(':');
                    
                    const hour24 = parseInt(hours);
                    const ampm = hour24 >= 12 ? 'P.M' : 'A.M';
                    const displayHours = hour24 % 12 || 12;
                    const displayMinutes = minutes.padStart(2, '0');
                    
                    return `${day}/${month}/${year} (${displayHours}:${displayMinutes} ${ampm})`;
                  })()}
                </td>
                <td className="tabledata-txt py-3">{request.narration}</td>
                <td className="tabledata-txt py-3">
                  {request.categoryType === "MonazamTransfer"
                    ? "Monazam to OPAP transfer"
                    : request.categoryType === "MonazamToEhajjTransfer"
                    ? "Monazam to E Hajj transfer"
                    : request.categoryType === "OpapTransfer"
                    ? "OPAP to E Hajj transfer"
                    : request.categoryType}
                </td>
                <td className="tabledata-txt py-3 col-currency">{request.currency}</td>
                <td className="tabledata-txt py-3 col-amount">
                  {formatAmount(request.amount)}
                </td>
                <td className="tabledata-txt py-3">
                  {request.fileUrl ? (
                    <div className="d-flex justify-content-center">
                      <button
                        className="btn btn-sm download-btn"
                        onClick={() => {
                          window.open(request.fileUrl, '_blank');
                        }}
                      >
                        <FaDownload className="download-icon" />
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <span className="text-muted">No file</span>
                    </div>
                  )}
                </td>
                {userType === "monazam" ? (
                  <td className="tabledata-txt py-3 col-actions">
                    {request.status === "pending" ? (
                      <div className="d-flex gap-2 action-buttons">
                    <button
                          className="btn btn-sm approved-btn"
                      onClick={() => {
                        approveRequest(request);
                      }}
                    >
                      Approve
                    </button>
                    <button
                      className="btn btn-sm rejectbtn"
                      onClick={() => {
                        rejectRequest(request);
                      }}
                    >
                      Reject
                    </button>
                      </div>
                    ) : (
                      <span className={`status-text ${request.status === "approved" ? "text-success" : "text-danger"}`}>
                        {request.status === "approved" ? "Approved" : request.status === "rejected" ? "Rejected" : request.status}
                      </span>
                    )}
                  </td>
                ) : (
                  <td className="tabledata-txt py-3 col-actions">
                    <span className={`status-text ${request.status === "approved" || request.status === "done" ? "text-success" : request.status === "rejected" ? "text-danger" : "text-muted"}`}>
                      {request.status === "approved" ? "Done" : request.status === "rejected" ? "Rejected" : request.status === "pending" ? "Pending" : request.status}
                    </span>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
};
export default Table;
